import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { DtVersionSelection } from "../types";
import { parseDtVersions, serializeDtVersions } from "../utils/dtVersions";

export const DT_VERSIONS_PARAM = "dtVersions";

/** Per-project Dependency-Track version choice, kept in the URL. */
export function useDtVersionSelection(): [
  DtVersionSelection,
  (selection: DtVersionSelection) => void,
] {
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = searchParams.get(DT_VERSIONS_PARAM);
  const selection = useMemo(() => parseDtVersions(raw), [raw]);

  const setSelection = useCallback(
    (next: DtVersionSelection) => {
      setSearchParams(
        (prev) => {
          const params = new URLSearchParams(prev);
          const value = serializeDtVersions(next);
          if (value) {
            params.set(DT_VERSIONS_PARAM, value);
          } else {
            params.delete(DT_VERSIONS_PARAM);
          }
          return params;
        },
        { replace: true },
      );
    },
    [setSearchParams],
  );

  return [selection, setSelection];
}
